import React from "react"
import styled from "styled-components"

const NogrammerLayout = styled.div`
	display: "flex";
	flex-direction: "column";
`

export default function NogrammerStyle(props) { return <NogrammerLayout> {props.children} </NogrammerLayout> }